import { jsx as _jsx } from "react/jsx-runtime";
import { NPCModalForm } from '../EntityModalForms/NPCModalForm';
import './CreateNPCModal.scss';
function CreateNPCModal({ isOpen, onClose, onCreate, isLoading }) {
    return (_jsx(NPCModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onCreate, isLoading: isLoading, mode: "create", npc: null, title: "Create New NPC", submitIdleLabel: "Create NPC", submitBusyLabel: "Creating..." }));
}
export default CreateNPCModal;
